import { FundingSource, VestingSchedule } from '@/models/PlanDesign.model';
import Helper from '@/routes/plans/plan-detail/PlanTab/Helper';

class ProfitSharing {
  convertToApiState = Helper.convertValueToApiState;

  fundingSources: FundingSource[];

  options: string[];

  output: string | undefined;

  vestingSchedules: VestingSchedule[];

  setOutput = (vestingSchedules: VestingSchedule[]): void => {
    this.output = Helper.getVestingScheduleName(
      'Profit Sharing',
      this.fundingSources,
      vestingSchedules
    );
  };

  setOptions = (vestingSchedules: VestingSchedule[]): void => {
    this.options = vestingSchedules.map(s => s.displayName);
  };

  set = (vestingSchedules: VestingSchedule[]): void => {
    this.setOutput(vestingSchedules);
    this.setOptions(vestingSchedules);
    this.vestingSchedules = vestingSchedules;
  };

  constructor(props: Record<string, any>) {
    this.fundingSources = props.fundingSources;
  }
}

export default ProfitSharing;
